import { UserTypeOption } from '@/graphql/generated'

export const userTypeToUserTypeOptionMapper = (userType: string | null) => {
  if (userType === null) return

  switch (userType) {
    case 'owner':
      return UserTypeOption.Owner

    case 'tenant':
      return UserTypeOption.Tenant

    case 'supplier':
      return UserTypeOption.Supplier

    default: {
      console.error(`userType ${userType} for mapping is invalid, only owner, tenant or supplier values are accepted`)
      return null
    }
  }
}
